import { defineStore } from 'pinia';

import { Config } from '@/config';
import apiService from '@/services/api.service';
import { useI18n } from 'vue-i18n';
import { Constants } from '@/constants';
import type { CommentDto, CommentSummaryDto } from '@/services/types/api.types';
import { insertOrUpdate } from '@/helpers/store.helper';

export interface CommentsState {
  comments: CommentDto[];
}

export const useCommentsStore = defineStore({
  id: 'comments',
  state: (): CommentsState => ({
    comments: [],
    // isLoaded: false
    // itemLoadingStates: new Set<number>(),
  }),
  getters: {
    getCommentsByFormId: (state) => (formId: number) => state.comments.filter((s) => s.form_id === formId),
    // isItemLoading: (state) => (formId: number) => state.itemLoadingStates.has(formId),
    // getItem: (state) => (formId: number) => state.forms.find(s => s.id === formId),
    // getFormsBySectionId: (state) => (sectionId: number) => state.forms.filter(s => s.section_id === sectionId),
    // getTypes: (state) => getTypes,
    // getStatuses: (state) => getStatuses,
  },
  actions: {
    async fetchComments() {
      // this.isLoaded = false
      try {
        const { data } = await apiService.get<any>(`${Config.api.v2}/forms/:get-all-comments`);
        for (const comment of data) {
          insertOrUpdate(this.comments, comment, 'id');
        }
      } catch (error) {
        console.error(error);
      } finally {
        // this.isLoaded = true
      }
    },

    async fetchCommentsByFormId(formId: number) {
      try {
        const { data } = await apiService.get<CommentDto[]>(`${Config.api.v2}/forms/${formId}/comments`);
        for (const comment of data) {
          insertOrUpdate(this.comments, comment, 'id');
        }
      } catch (error) {
        console.error(error);
      }
    },

    async saveSummaryEntry(commentId: number, summaryId: number, text: string) {
      try {
        const formId = this.comments.find((c) => c.id === commentId)?.form_id;
        if (summaryId === -1) {
          await apiService.post<CommentSummaryDto>(`${Config.api.v2}/forms/${formId}/comments/${commentId}/summaries`, {
            text,
          });
        } else {
          await apiService.put<CommentSummaryDto>(
            `${Config.api.v2}/forms/${formId}/comments/${commentId}/summaries/${summaryId}`,
            { text },
          );
        }
        await this.fetchCommentsByFormId(formId);
        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    },

    async deleteSummaryEntry(commentId: number, summaryId: number) {
      try {
        const formId = this.comments.find((c) => c.id === commentId)?.form_id;
        await apiService.delete(`${Config.api.v2}/forms/${formId}/comments/${commentId}/summaries/${summaryId}`);
        await this.fetchCommentsByFormId(formId);
        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    },

    // async moderateComment(form: FormDto): Promise<boolean> {
    // try {
    //     if (form.id) {
    //         await apiService.put(`${Config.api.v2}/forms/${form.id}`, form);
    //     } else {
    //         await apiService.post(`${Config.api.v2}/forms`, form);
    //     }
    //     this.fetchFormsBySection(form.section_id); // TODO get the id from the post and use the id to fetch only the new form
    //     return true;
    // } catch (error) {
    //     console.error(error);
    //     return false;
    // }
    // }
  },
});
